import { queryOptions, useQuery } from "@tanstack/react-query";
import { api } from "../../lib/api.js";
export const getClient = async ({ userId, }) => {
    const searchParams = new URLSearchParams();
    searchParams.append("dash", "true");
    searchParams.append("expand", "goal");
    searchParams.append("expand", "best_sets");
    searchParams.append("expand", "latest_sets");
    const client = await api
        .get(`clients/${userId}`, {
        searchParams: searchParams,
    })
        .json();
    if (!("quick_notes" in client)) {
        client.quick_notes = "";
    }
    if (!("tags" in client)) {
        client.tags = [];
    }
    if (!client.workout_times) {
        const convertedAvailability = [];
        for (let i = 0; i < 7; i++) {
            const availableDay = {
                time: null,
                has_time: false,
                anytime: null,
            };
            convertedAvailability.push(availableDay);
        }
        client.workout_times = convertedAvailability;
    }
    if (!client.equipment_detailed || client.equipment_detailed === null) {
        client.equipment_detailed = {};
    }
    return client;
};
export const getClientQueryOptions = (userId) => {
    return queryOptions({
        queryKey: ["clients", userId],
        queryFn: () => getClient({ userId }),
        staleTime: 1000 * 5,
    });
};
export const useClient = ({ queryConfig, userId }) => {
    return useQuery({
        ...getClientQueryOptions(userId),
        ...queryConfig,
    });
};
//# sourceMappingURL=getClient.js.map